/*
  Quiz SOMA (qzb) — navegação em telas estilo stories.
  Uma tela por vez; a seta só libera depois de responder. A resposta não muda depois
  de escolhida (como no quiz do Instagram). Na captação, cria o cliente com a tag
  (form customer, em segundo plano) e então envia o formulário de contato de verdade,
  que leva tudo para Mensagens. Na volta (?contact_posted=true) mostra o agradecimento.
*/
(function () {
  if (window.__qzb) return;
  window.__qzb = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var STORE = 'qzb-result';

  function store(v) {
    try {
      if (v === undefined) return JSON.parse(sessionStorage.getItem(STORE) || 'null');
      sessionStorage.setItem(STORE, JSON.stringify(v));
    } catch (_) {}
    return null;
  }

  function init(root) {
    if (!root || root.__qzb) return;
    root.__qzb = true;
    root.classList.add('is-js');

    /* Um <dialog> modal aberto dentro de algo escondido (ex.: pop-up de app no rodapé
       escondido pela tela cheia) deixa a página inteira sem clique. Fecha esses. */
    if (root.hasAttribute('data-no-popups')) {
      var freeModals = function () {
        document.querySelectorAll('dialog[open]').forEach(function (d) {
          if (!root.contains(d) && d.matches(':modal') && !d.getClientRects().length) d.close();
        });
      };
      freeModals();
      document.addEventListener('pointerdown', freeModals, true);
      document.addEventListener('keydown', freeModals, true);
    }

    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-qzb-step]'));
    var bars = Array.prototype.slice.call(root.querySelectorAll('.qzb__bar'));
    var live = root.querySelector('[data-qzb-live]');
    var form = root.querySelector('[data-qzb-form]');
    var customer = root.querySelector('[data-qzb-customer]');
    var current = -1;
    var answers = []; // por tela de pergunta: { q, a, ok }

    function say(t) { if (live) { live.textContent = ''; setTimeout(function () { live.textContent = t; }, 60); } }

    // tela i → índice da barra (abertura não tem barra; agradecimento enche todas)
    function barOf(i) { return i - 1; }
    function isDone(i) { var st = steps[i]; return !!st && st.__done; }

    function paintBars() {
      var kind = steps[current] && steps[current].getAttribute('data-qzb-step');
      bars.forEach(function (b, j) {
        var full = kind === 'done' || j < barOf(current) || (j === barOf(current) && isDone(current));
        b.classList.toggle('is-full', full);
        b.classList.toggle('is-half', !full && j === barOf(current));
      });
    }

    /* Tela cheia: a tela ativa precisa caber sem rolagem. Mede com o Dato SOMA já
       ocupando espaço (invisível) para nada pular depois de responder, e reduz a
       escala do conteúdo até caber. */
    var full = root.classList.contains('qzb--full');
    var redirect = root.getAttribute('data-redirect') || '';
    function request_design_mode() { return !!(window.Shopify && window.Shopify.designMode); }
    function fit(st) {
      st = st || steps[current];
      if (!full || !st) return;
      var body = st.querySelector('.qzb__body');
      var tips = Array.prototype.filter.call(st.querySelectorAll('[data-qzb-tip]'), function (t) { return t.hidden; });
      tips.forEach(function (t) { t.classList.add('is-measure'); });
      var k = 1;
      st.style.setProperty('--qzb-k', k);
      while (body.scrollHeight > body.clientHeight + 1 && k > 0.7) {
        k = Math.round((k - 0.03) * 100) / 100;
        st.style.setProperty('--qzb-k', k);
      }
      tips.forEach(function (t) { t.classList.remove('is-measure'); });
    }
    var fitTimer;
    window.addEventListener('resize', function () {
      var a = document.activeElement;
      if (a && /INPUT|TEXTAREA/.test(a.tagName)) return; // teclado abrindo: não reescala
      clearTimeout(fitTimer);
      fitTimer = setTimeout(function () { fit(); }, 120);
    });
    // a medida muda quando a Lato termina de carregar (a fonte reserva é mais larga)
    if (document.fonts) {
      if (document.fonts.ready) document.fonts.ready.then(function () { fit(); });
      if (document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', function () { fit(); });
    }
    window.addEventListener('load', function () { fit(); });

    function show(i, focus) {
      if (i < 0 || i >= steps.length || i === current) return;
      var first = current < 0;
      steps.forEach(function (s) { if (s !== steps[i]) s.classList.remove('is-active', 'is-entering'); });
      current = i;
      var st = steps[i];
      st.classList.add('is-active');
      if (!reduce && !first) { // a primeira tela já vem pronta do HTML: sem animar
        st.classList.add('is-entering');
        st.addEventListener('animationend', function off(e) { if (e.target === st) { st.classList.remove('is-entering'); st.removeEventListener('animationend', off); } });
      }
      paintBars();
      fit(st);
      if (!full) {
        var top = root.getBoundingClientRect().top + window.pageYOffset;
        if (Math.abs(window.pageYOffset - top) > 2) window.scrollTo(0, top);
      }
      if (focus) {
        var target = st.querySelector('legend, label.qzb-card__q, h1, h2') || st;
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      }
    }

    function ready(st) {
      st.__done = true;
      var btn = st.querySelector('[data-qzb-next]');
      if (btn && btn.disabled) {
        btn.disabled = false;
        btn.classList.remove('is-ready');
        void btn.offsetWidth;
        btn.classList.add('is-ready');
      }
      paintBars();
    }

    function unready(st) {
      st.__done = false;
      var btn = st.querySelector('[data-qzb-next]');
      if (btn) btn.disabled = true;
      paintBars();
    }

    /* ---------- perguntas de opção ---------- */
    steps.forEach(function (st, i) {
      if (st.getAttribute('data-kind') !== 'choice') return;
      var card = st.querySelector('.qzb-card');
      var correct = st.getAttribute('data-correct') || 'any';
      var q = (st.querySelector('legend') || {}).textContent || '';
      var tip = st.querySelector('[data-qzb-tip]');
      var opts = Array.prototype.slice.call(st.querySelectorAll('[data-qzb-opt]'));
      var picked = null;

      st.addEventListener('change', function (e) {
        var input = e.target;
        if (!input.matches('input[type=radio]')) return;
        if (picked) { picked.checked = true; return; }
        picked = input;
        var key = input.value;
        var any = correct === 'any';
        card.classList.add('is-answered');
        opts.forEach(function (o) {
          var k = o.getAttribute('data-qzb-opt');
          var mine = k === key;
          if (any) {
            o.classList.add(mine ? 'is-chosen' : 'is-other');
          } else {
            o.classList.add(k === correct ? 'is-right' : 'is-wrong');
            if (mine) o.classList.add('is-picked');
          }
          var r = o.querySelector('input');
          if (!mine) r.disabled = true;
        });
        var ok = any ? null : key === correct;
        answers[i] = { q: q.trim(), a: input.getAttribute('data-label') || key, ok: ok };
        if (tip) {
          tip.hidden = false;
          if (!reduce) tip.classList.add('is-in');
        }
        var right = opts.filter(function (o) { return o.getAttribute('data-qzb-opt') === correct; })[0];
        var msg = ok === null ? '' : ok ? '¡Correcto! ' : 'Incorrecto. La respuesta es: ' + (right ? right.querySelector('.qzb-opt__text').textContent : '') + '. ';
        say(msg + (tip ? tip.textContent.replace(/\s+/g, ' ').trim() : ''));
        ready(st);
      });
    });

    /* ---------- pergunta aberta ---------- */
    steps.forEach(function (st, i) {
      if (st.getAttribute('data-kind') !== 'open') return;
      var field = st.querySelector('[data-qzb-open]');
      var q = (st.querySelector('.qzb-card__q') || {}).textContent || '';
      field.addEventListener('input', function () {
        var v = field.value.trim();
        answers[i] = { q: q.trim(), a: v, ok: null };
        if (v.length >= 2) ready(st); else unready(st);
      });
    });

    /* ---------- seta ---------- */
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qzb-next]');
      if (!btn || btn.disabled || !root.contains(btn)) return;
      show(current + 1, true);
    });

    /* ---------- captação ---------- */
    function digits(v) { return String(v || '').replace(/\D+/g, ''); }

    function validate() {
      var bad = [];
      var name = form.querySelector('[data-qzb-name]');
      var email = form.querySelector('[data-qzb-email]');
      var phone = form.querySelector('[data-qzb-phone]');
      var prefix = phone.getAttribute('data-prefix') || '';
      var raw = phone.value.trim();
      var d = digits(raw);
      var cc = digits(prefix);
      // já veio com o código do país (+57 300..., 57300...): não soma o prefixo de novo
      var withCc = /^\+/.test(raw) || (cc && d.indexOf(cc) === 0 && d.length > 10);
      var phoneOut = withCc ? '+' + d : (prefix ? prefix + ' ' : '') + d;
      var checks = [
        [name, name.value.trim().length >= 2],
        [email, EMAIL_RE.test(email.value.trim())],
        [phone, d.length >= 7 && d.length <= 15],
      ];
      checks.forEach(function (c) {
        var f = c[0].closest('.qzb-field');
        f.classList.toggle('is-invalid', !c[1]);
        c[0].setAttribute('aria-invalid', c[1] ? 'false' : 'true');
        if (!c[1]) bad.push(c[0]);
      });
      return { bad: bad, name: name.value.trim(), email: email.value.trim(), phone: phoneOut };
    }

    function summary(v) {
      var tag = root.getAttribute('data-tag') || '';
      var right = 0, total = 0, lines = [];
      answers.forEach(function (a) {
        if (!a) return;
        if (a.ok !== null) { total++; if (a.ok) right++; }
        lines.push((lines.length + 1) + '. ' + a.q + '\n   ' + a.a + (a.ok === null ? '' : a.ok ? ' (correcta)' : ' (incorrecta)'));
      });
      var body = ['Quiz: ' + tag, 'Nombre: ' + v.name, 'Correo: ' + v.email, 'Celular: ' + v.phone, 'Aciertos: ' + right + ' de ' + total, '', lines.join('\n')].join('\n');
      return { body: body, right: right, total: total };
    }

    /* A loja exige captcha (hCaptcha invisível) também no form de cliente: um fetch
       direto recebe 400 "Missing CAPTCHA token". Por isso o cliente vai pelo envio
       nativo (o script da Shopify põe o token), com target num iframe escondido. */
    var sink = null;
    function post(f, ms) {
      return new Promise(function (resolve, reject) {
        if (!sink) {
          sink = document.createElement('iframe');
          sink.name = 'qzb-sink-' + (root.id || 'quiz');
          sink.title = 'envío';
          sink.tabIndex = -1;
          sink.setAttribute('aria-hidden', 'true');
          sink.style.cssText = 'position:absolute;width:1px;height:1px;border:0;opacity:0;pointer-events:none;left:-9999px';
          document.body.appendChild(sink);
        }
        var timer = setTimeout(function () { done(); reject(new Error('timeout')); }, ms || 25000);
        var done = function () { clearTimeout(timer); sink.onload = null; f.removeAttribute('target'); f.__go = false; };
        sink.onload = function () {
          var u = '';
          try { u = sink.contentWindow.location.href; } catch (_) { u = 'cross-origin'; }
          if (!u || u === 'about:blank') return;
          done();
          resolve(u);
        };
        f.target = sink.name;
        f.__go = true;
        if (f.requestSubmit) f.requestSubmit(); else f.submit();
      });
    }

    function toCustomer(v) {
      if (!customer) return Promise.resolve();
      var parts = v.name.split(/\s+/);
      var set = function (n, val) { var i = customer.querySelector('[name="' + n + '"]'); if (i) i.value = val; };
      set('contact[email]', v.email);
      set('contact[first_name]', parts.shift());
      set('contact[last_name]', parts.join(' '));
      return post(customer, 8000).catch(function () {});
    }

    if (form) {
      form.addEventListener('input', function (e) {
        var f = e.target.closest('.qzb-field');
        if (f && f.classList.contains('is-invalid')) { f.classList.remove('is-invalid'); e.target.setAttribute('aria-invalid', 'false'); }
      });
      /* O botão é type="button": nenhum script do tema/Shopify envia o formulário
         antes da validação. Com tudo certo, o envio é o nativo da Shopify (que exige
         captcha e cuida dele) com return_to para a página de agradecimento do setting. */
      var native = function () {
        var back = form.querySelector('[data-qzb-return]');
        if (back) { back.disabled = false; back.value = redirect || location.pathname + location.search.replace(/[?&]contact_posted=true/, ''); }
        try { sessionStorage.setItem('qzb-native', '1'); } catch (_) {}
        form.__go = true;
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      };
      var send = function () {
        if (form.classList.contains('is-busy') || form.__go) return;
        var v = validate();
        if (v.bad.length) { fit(); v.bad[0].focus(); return; }
        var sum = summary(v);
        form.querySelector('[data-qzb-body]').value = sum.body;
        form.querySelector('[data-qzb-phone]').value = v.phone;
        store({ name: v.name.split(/\s+/)[0], right: sum.right, total: sum.total });
        form.classList.add('is-busy');
        // cliente com a tag em segundo plano (melhor esforço), depois o contato pelo
        // envio nativo da Shopify, que cuida do captcha e leva à página de agradecimento
        toCustomer(v).then(native, native);
      };
      form.querySelector('[data-qzb-submit]').addEventListener('click', send);
      form.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && e.target.matches('input')) { e.preventDefault(); send(); }
      });
      // qualquer outro envio (Enter, script de terceiros) passa pela validação antes
      form.addEventListener('submit', function (e) {
        if (form.__go) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        send();
      }, true);
    }

    /* ---------- agradecimento ---------- */
    function fillDone() {
      var r = store();
      var done = root.querySelector('[data-qzb-step="done"]');
      if (!done || !r) return;
      if (r.name) done.querySelector('[data-qzb-done-name]').textContent = ', ' + r.name + '!';
      var sc = done.querySelector('[data-qzb-score]');
      var label = root.getAttribute('data-score') || '';
      if (sc && label && r.total) {
        sc.textContent = label.replace('[n]', r.right).replace('[t]', r.total);
        sc.hidden = false;
      }
    }

    var doneIdx = steps.findIndex(function (s) { return s.getAttribute('data-qzb-step') === 'done'; });
    var capIdx = steps.findIndex(function (s) { return s.getAttribute('data-qzb-step') === 'capture'; });
    // volta do envio nativo (captcha): a Shopify pode não devolver ?contact_posted
    var nativeBack = false;
    try { nativeBack = sessionStorage.getItem('qzb-native') === '1'; sessionStorage.removeItem('qzb-native'); } catch (_) {}
    var failed = form && form.querySelector('.qzb-cap__fail');
    if (root.querySelector('[data-qzb-posted]') || (nativeBack && !failed)) {
      // a Shopify voltou para esta página em vez do return_to: segue para o agradecimento
      if (redirect && !request_design_mode()) { location.replace(redirect); return; }
      fillDone();
      show(doneIdx, false);
    } else if (failed) {
      show(capIdx, false);
    } else {
      show(0, false);
    }

    /* editor de tema: selecionar um bloco mostra a tela dele */
    root.__show = function (el) { var i = steps.indexOf(el); if (i > -1) show(i, false); };
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-qzb]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest('[data-qzb]');
    if (root && root.__show) root.__show(e.target);
  });
})();
